<div class="h-full overflow-auto border-t border-gray-200 min-h-[500px]">
    <table class="w-full text-left text-base">
        <thead class="sticky top-0 z-10 bg-gray-50">
        <tr class="border-b border-gray-200">
            <th class="px-5 py-4 text-sm font-semibold uppercase tracking-wide text-gray-600">
                SN
            </th>

            @for (field of displayFields; track field.key) {
                <th class="px-5 py-4 text-sm font-semibold uppercase tracking-wide text-gray-600 whitespace-nowrap">
                    {{ field.label || field.key }}
                </th>
            }
        </tr>
        </thead>

        <tbody>
            @for (item of data; track $index) {
                <tr class="border-b border-gray-100 transition-colors duration-150 hover:bg-gray-50">

                    <td class="px-5 py-4 font-medium text-gray-600">
                        {{ $index + 1 }}
                    </td>

                    @for (field of displayFields; track field.key) {
                        <td class="px-5 py-4 font-normal text-gray-700 whitespace-nowrap">
                            {{ item[field.key] ?? '-' }}
                        </td>
                    }

                </tr>
            }
        </tbody>
    </table>
</div>

<!--@for (item of data; track $index) {-->
<!--    <div class="border rounded-lg p-4 mb-4">-->
<!--        <div class="grid grid-cols-6 gap-4">-->
<!--            @for (field of displayFields; track field.key) {-->
<!--                <app-data-display-->
<!--                        [label]="field.label || field.key"-->
<!--                        [value]="item[field.key] ?? '-'">-->
<!--                </app-data-display>-->
<!--            }-->
<!--        </div>-->
<!--    </div>-->
<!--}-->